import React, { useContext } from 'react';
import { ApplicationTrackerContext } from '../../contexts/ApplicationTrackerContext';

const AutoScraperInfoModal = () => {
  const { setAutoScraperInfoModalOpen, enableEmailScraping } =
    useContext(ApplicationTrackerContext);

  const handleEnableEmailScraping = () => {
    // Store current path to redirect back after auth
    localStorage.setItem('returnToPath', '/application-tracking');
    setAutoScraperInfoModalOpen(false);
    // Small delay to allow modal to close
    setTimeout(() => {
      enableEmailScraping();
    }, 300);
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center px-4">
        <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
        <div className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
          <div className="absolute right-0 top-0 pr-4 pt-4">
            <button
              onClick={() => setAutoScraperInfoModalOpen(false)}
              type="button"
              className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-hidden"
            >
              <span className="sr-only">Close</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="text-center sm:mt-5">
            <h3 className="text-2xl font-semibold leading-6 text-gray-900">Sync with Gmail</h3>
            <div className="mt-4">
              <p className="text-md text-gray-500">
                We only look for internship-related emails and store application data to help you
                track your progress. We never share your personal data with third parties.
              </p>
              <br />
              <p className="text-md text-gray-500">
                <strong>
                  Make sure you sign in with the email you used to login to InternHub!
                </strong>{' '}
                If you want to sync a different email, message support@internhubapp.com.
              </p>
            </div>
          </div>
          <div className="mt-6 flex justify-center">
            <button
              onClick={handleEnableEmailScraping}
              type="button"
              className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-hidden focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
            >
              Go to sign-in!
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoScraperInfoModal;
